import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faGavel, faDollarSign, faUsers, faHotel, faPeopleCarry, so } from '@fortawesome/free-solid-svg-icons'

import './styles.css';
import Publity from './components/publity';
import Who from './components/who';
import Contact from './components/contact';

import ScrollableAnchor, { goToAnchor } from 'react-scrollable-anchor'

export default function Content({ anchor }) {
    goToAnchor(anchor);
    const civelRef = useRef(null);
    const familiaRef = useRef(null);
    const cobrancaRef = useRef(null);
    const condominioRef = useRef(null);
    const empresarialRef = useRef(null);

    const groupCivel = useRef(null);
    const groupCobranca = useRef(null);
    const groupCondominio = useRef(null);
    const groupEmpresarial = useRef(null);
    const groupFamilia = useRef(null);


    function showCivel(e) {
        familiaRef.current.style.display = 'none'
        cobrancaRef.current.style.display = 'none'
        condominioRef.current.style.display = 'none'
        empresarialRef.current.style.display = 'none'

        
        civelRef.current.style.display == 'none' || civelRef.current.style.display == '' ? civelRef.current.style.display = 'block' : civelRef.current.style.display = 'none'

        if (civelRef.current.style.display == 'block') {
            groupCivel.current.style.height = 'auto';
            groupFamilia.current.style.height = '200px';
            groupCobranca.current.style.height = '200px';
            groupCondominio.current.style.height = '200px';
            groupEmpresarial.current.style.height = '200px';
        } else {
            groupCivel.current.style.height = '200px';

        }


    }

    function showFamily(e) {
        civelRef.current.style.display = 'none'
        cobrancaRef.current.style.display = 'none'
        condominioRef.current.style.display = 'none'
        empresarialRef.current.style.display = 'none'

        familiaRef.current.style.display == 'none' || familiaRef.current.style.display == '' ? familiaRef.current.style.display = 'block' : familiaRef.current.style.display = 'none'

        if (familiaRef.current.style.display == 'block') {
            groupFamilia.current.style.height = 'auto';
            groupCivel.current.style.height = '200px';
            groupCobranca.current.style.height = '200px';
            groupCondominio.current.style.height = '200px';
            groupEmpresarial.current.style.height = '200px';
        } else {
            groupFamilia.current.style.height = '200px'
        }


    }

    function showCobranca(e) {
        civelRef.current.style.display = 'none'
        familiaRef.current.style.display = 'none'
        condominioRef.current.style.display = 'none'
        empresarialRef.current.style.display = 'none'

        cobrancaRef.current.style.display == 'none' || cobrancaRef.current.style.display == '' ? cobrancaRef.current.style.display = 'block' : cobrancaRef.current.style.display = 'none'

        if (cobrancaRef.current.style.display == 'block') {
            groupCobranca.current.style.height = 'auto';
            groupCivel.current.style.height = '200px';
            groupFamilia.current.style.height = '200px';
            groupCondominio.current.style.height = '200px';
            groupEmpresarial.current.style.height = '200px';
        } else {
            groupCobranca.current.style.height = '200px';
        }


    }

    function showCondominio(e) {

        civelRef.current.style.display = 'none'
        familiaRef.current.style.display = 'none'
        cobrancaRef.current.style.display = 'none'
        empresarialRef.current.style.display = 'none'

        condominioRef.current.style.display == 'none' || condominioRef.current.style.display == '' ? condominioRef.current.style.display = 'block' : condominioRef.current.style.display = 'none'

        if (condominioRef.current.style.display == 'block') {
            groupCondominio.current.style.height = 'auto';
            groupCivel.current.style.height = '200px';
            groupCobranca.current.style.height = '200px';
            groupFamilia.current.style.height = '200px';
            groupEmpresarial.current.style.height = '200px';
            
        } else {
            groupCondominio.current.style.height = '200px';

        }

    }

    function showEmpresarial(e) {

        civelRef.current.style.display = 'none'
        familiaRef.current.style.display = 'none'
        cobrancaRef.current.style.display = 'none'
        condominioRef.current.style.display = 'none'


        empresarialRef.current.style.display == 'none' || empresarialRef.current.style.display == '' ? empresarialRef.current.style.display = 'block' : empresarialRef.current.style.display = 'none'

        if (empresarialRef.current.style.display == 'block') {
            groupEmpresarial.current.style.height = 'auto';
            groupCivel.current.style.height = '200px';
            groupCobranca.current.style.height = '200px';
            groupFamilia.current.style.height = '200px';
        } else {
            groupEmpresarial.current.style.height = '200px';
        }

    }

    return (
        <>

        <div id="whatsApp">
            <a href="https://api.whatsapp.com/send?phone=5517991447466&text=Qual%20sua%20d%C3%BAvida%3F" target="_blank">
                <img src={require('../../assets/img/whatsapp.png')}/>
            </a>
        </div>
            <ScrollableAnchor id={'fazemos'}>
                <div className="content">
                    <h2 style={{ textAlign: 'center' }}>Área de atuação</h2>
                    <p style={{ textAlign: 'center' }}>Dos primeiros passos para criação da empresa ao último respiro, nossa intenção é ajudá-lo a encontrar soluções jurídicas eficientes e descomplicadas</p>

                    <div className="group-all">

                        <div className="group-itens" ref={groupCivel}>

                            <div className="icon" onClick={(e) => showCivel(e)}>
                                <FontAwesomeIcon icon={faGavel}
                                    size="3x"
                                    color="#bf9f62"
                                />
                            </div>
                            <h3>Cível</h3>

                            <ul ref={civelRef}>
                                <li>Contratos em Geral (compra e venda, confissão de dívida, prestação de serviço)</li>
                                <li>  Locação (ação de despejo, revisional, renovatória) </li>
                            </ul>
                        </div>

                        <div className="group-itens" ref={groupCobranca}>
                            <div className="icon" onClick={showCobranca}>
                                <FontAwesomeIcon icon={faDollarSign} size="3x" color="#bf9f62" />
                            </div>
                            <h3>Cobrança</h3>
                            <ul ref={cobrancaRef}>
                                <li>Ação de Indenização (dano moral, material, lucros cessantes)</li>
                                <li>Bancário (revisional, cobrança abusiva)</li>
                                <li>Execução (cheque, duplicata, contratos)</li>
                                <li>Imobiliário (adjudicação compulsória, consultoria documentação para aquisição de imóvel, rescisão)</li>
                                <li>Alienação de Bens</li>
                                <li>Condomínio</li>
                                <li>Tutelas de urgência de forma geral</li>
                                <li>Mandado de Segurança</li>
                            </ul>


                        </div>

                        <div className="group-itens" ref={groupCondominio}>
                            <div className="icon" onClick={showCondominio}>
                                <FontAwesomeIcon icon={faPeopleCarry} size="3x" color="#bf9f62" />
                            </div>
                            <h3>Consumidor </h3>
                            <ul ref={condominioRef}>
                                <li>Ação de Indenização (dano moral, material, lucros cessantes)</li>
                                <li>Bancário (revisional, cobrança abusiva)</li>
                                <li>Execução (cheque, duplicata, contratos)</li>
                                <li>Imobiliário (adjudicação compulsória, consultoria documentação para aquisição de imóvel, rescisão)</li>
                                <li>Alienação de Bens  </li>
                            </ul>


                        </div>

                        <div className="group-itens" ref={groupFamilia}>
                            <div className="icon" onClick={showFamily}>
                                <FontAwesomeIcon icon={faUsers} size="3x" color="#bf9f62" />
                            </div>
                            <h3>Familia e Sucessões</h3>
                            <ul ref={familiaRef}>
                                <li>Divórcio (Judicial, Extrajudicial, Consensual, Litigioso)</li>
                                <li>Guarda e Visita</li>
                                <li>Alimentos (fixação, majoração, minoração, exoneração)</li>
                                <li>Filiação (investigação de paternidade, negativa de paternidade, paternidade socioafetiva)</li>
                                <li>Busca e Apreensão</li>
                                <li> União Estável (formalização, reconhecimento, dissolução)</li>
                                <li>Registro Civil</li>
                                <li>Interdição</li>
                                <li> Regime de Bens (orientação, anulação, modificação)</li>
                                <li> Inventário (judicial e extrajudicial)</li>
                                <li> Partilha de Bens</li>
                                <li>Testamentos</li>
                                <li>Pedido de Alvará</li>
                                <li>Planejamento sucessório</li>
                                <li> Tutelas de urgência de forma geral</li>
                            </ul>


                        </div>

                        <div className="group-itens" ref={groupEmpresarial}>
                            <div className="icon" onClick={showEmpresarial}>
                                <FontAwesomeIcon icon={faHotel} size="3x" color="#bf9f62" />
                            </div>
                            <h3>Empresarial</h3>
                            <ul ref={empresarialRef}>
                                <li> Assessoria</li>
                                <li> Consultoria</li>
                                <li> Contratos</li>
                                <li> Dissolução de sociedade</li>
                                <li> Cobrança</li>
                                <li> Direito do Consumidor</li>
                                <li> Trabalhista</li>
                                <li> Tributário</li>
                                <li> Responsabilidade Civil</li>
                                <li> Indenizações</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ScrollableAnchor>

            <section id="publity">
                <Publity handleAnchor={() => goToAnchor('contact')} />
            </section>


            <ScrollableAnchor id={'who'}>
                <section id="who">
                    <Who />
                </section>
            </ScrollableAnchor>

            <ScrollableAnchor id={'contact'}>
                <section id="contact">
                    <Contact />
                </section>
            </ScrollableAnchor>
        </>
    )
}